import FilesPedidosClient from '@/api/Operacoes/files.client';
import Store from '@/store';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';

export default class FilesService {
  constructor() {
    this.client = new FilesPedidosClient();
    this.notify = new Notifier();
    this.vuex = Store;
  }

  async indexFiles(pedidoId, referenciaBo) {
    try {
      this.vuex.commit('filesStore/SET_IS_LOADING', true);
      const response = await this.client.gerarPdfPedidos(pedidoId, referenciaBo);
      const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

      this.vuex.commit('filesStore/SET_GENERATED_LABEL_URL', url);
      this.notify.success('PDF gerado com sucesso', 'Sucesso');
    } catch (error) {
      console.error(error, 'Erro ao gerar PDF do pedido');
      // A resposta de erro chega como Blob (responseType: 'blob') — extrai a
      // mensagem real do backend para o usuário saber o que houve.
      let msg = 'Erro ao gerar o PDF do pedido';
      try {
        const data = error?.response?.data;
        if (data instanceof Blob) {
          const parsed = JSON.parse(await data.text());
          if (parsed?.message) msg = parsed.message;
        } else if (data?.message) {
          msg = data.message;
        }
      } catch (e) { /* mantém mensagem genérica */ }
      this.notify.error(msg, 'Erro ao gerar PDF');
      this.vuex.commit('filesStore/SET_GENERATED_LABEL_URL', '');
      throw error;
    } finally {
      this.vuex.commit('filesStore/SET_IS_LOADING', false);
    }
  }
}
